export const projects = () => {

    const $filtersList =	$('.js-filters-list');
    const filtersList	=	'.js-filters-list';

    const $filterItem	=	$('.js-filter');

    const $item	=	$('.js-item-to-filter');
    const item =	'.js-item-to-filter';

    const init = () => {

        if ($filtersList.length) {
            var $activeItem;
            if($filtersList.find('.is-active').length) {
                $activeItem = $filtersList.find('.is-active');
                filterItemsByTag($activeItem.attr('data-tag'));
            } else {
                $activeItem = $filterItem.eq(0);
                $activeItem.addClass('is-active');
                filterItemsByTag($activeItem.attr('data-tag'));
            }
        }
  
      bind();
  
    };
  
    const bind = () => {
 
        $filterItem.on('click', function(evt) {
          evt.preventDefault();
          $('.js-collapsible-section').attr('data-collapsed', 'false');
          $('.js-collapsible-section').children('.js-collapsible-section-content').css({'max-height':'auto'});
          //Add active class to listitem of filters
          $filtersList.find('.is-active').removeClass('is-active');
          $filtersList.find('[data-tag="' + $(this).attr('data-tag') + '"]').addClass('is-active');
          filterItemsByTag($(this).attr('data-tag'));
        });
  
    };
  
    const filterItemsByTag = (filterValue) => {
  
        if(filterValue === '') {
            $(item).removeClass('u-hidden');
            $('.c-collection').removeClass('u-hidden');
        } else {
            
            $(item).addClass('u-hidden');
            $(item+'[data-tag*="'+filterValue+'"]').removeClass('u-hidden');
            $('.c-collection').each(function() {
                if($(this).find($(item+':not(.u-hidden)')).length == 0) {
                    $(this).addClass('u-hidden');
                } else {
                    $(this).removeClass('u-hidden');
                }
            });
        }
  
    };
  
    if ($filtersList.length > 0) {
        init();
    }
  
};
